/**
 * Mapeo de abreviaturas de días a nombres de días utilizados en la configuración de visitas.
 */
const DAY_MAP: Record<string, string> = {
    'lu': 'LUNES', 'lun': 'LUNES', 'ma': 'MARTES', 'mar': 'MARTES', 'mi': 'MIERCOLES', 'mie': 'MIERCOLES', 'mié': 'MIERCOLES',
    'ju': 'JUEVES', 'jue': 'JUEVES', 'vi': 'VIERNES', 'vie': 'VIERNES', 'sa': 'SABADO', 'sab': 'SABADO', 'sá': 'SABADO', 'sáb': 'SABADO',
    'do': 'DOMINGO', 'dom': 'DOMINGO'
};

const DAYS_ORDER = ['LUNES', 'MARTES', 'MIERCOLES', 'JUEVES', 'VIERNES', 'SABADO', 'DOMINGO'];

/**
 * Parsea una cadena en formato "Lu-Vi 08:00-17:00; Sa 09:00-12:00"
 * Devuelve null si la cadena es inválida para permitir el fallback a la configuración global.
 */
export const parseScheduleString = (scheduleStr: string | null | undefined): Record<string, { INICIO: number; FIN: number }> | null => {
    if (!scheduleStr || typeof scheduleStr !== 'string' || !scheduleStr.trim()) return null;
    
    try {
        const horario: Record<string, { INICIO: number; FIN: number }> = {};
        const segments = scheduleStr.split(';').map(s => s.trim());

        segments.forEach(segment => {
            const match = segment.match(/^([a-z,\-\sáéíóú]+)\s+([0-9]{1,2}:[0-9]{2})-([0-9]{1,2}:[0-9]{2})$/i);
            if (!match) return; // Skip invalid segment instead of throwing

            const startHour = parseInt(match[2].split(':')[0], 10);
            const endHour = parseInt(match[3].split(':')[0], 10);
            const dayPart = match[1].toLowerCase();

            dayPart.split(',').forEach(daySeg => {
                const trimmedDaySeg = daySeg.trim();
                if (trimmedDaySeg.includes('-')) {
                    const [startKey, endKey] = trimmedDaySeg.split('-').map(d => d.trim());
                    const startIndex = DAYS_ORDER.indexOf(DAY_MAP[startKey]);
                    const endIndex = DAYS_ORDER.indexOf(DAY_MAP[endKey]);
                    if (startIndex !== -1 && endIndex !== -1) {
                        // Handle circular ranges or reverse ranges? 
                        // For simplicity, just handle forward ranges.
                        const start = Math.min(startIndex, endIndex);
                        const end = Math.max(startIndex, endIndex);
                        for (let i = start; i <= end; i++) {
                            horario[DAYS_ORDER[i]] = { INICIO: startHour, FIN: endHour };
                        }
                    }
                } else if (DAY_MAP[trimmedDaySeg]) {
                    horario[DAY_MAP[trimmedDaySeg]] = { INICIO: startHour, FIN: endHour };
                }
            });
        });
        return Object.keys(horario).length > 0 ? horario : null;
    } catch (e) {
        console.error("Scale Parser Error:", e);
        return null;
    }
};
